export const MOVE_DELAY = 1100;
export const MOVE_DELAY_STEP = 100;
export const MAX_SPEED_VALUE = 10;
export const AUTO_SPEED_DELAY = 30000;
export const SCORE_INCREMENT = 100;
export const MOVES_PER_SPAWN = 5;

export const FOOD = [
  '🍕',
  '🍔',
  '🌭',
  '🥨',
  '🧀',
  '🥪',
  '🌮',
  '🍖',
  '🍗',
  '🥩',
  '🍘',
  '🍙',
  '🍣',
  '🍤',
  '🍦',
  '🍩',
  '🍰',
  '🧁',
  '🐟',
  '🐠',
];
